import { ctx, hasRR } from './canvas.js';

export const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

export const rand = (a, b) => Math.floor(a + Math.random() * (b - a + 1));

/** Rounded rectangle fill, falling back to a plain rect on old engines. */
export function rr(px, py, w, h, r) {
  if (hasRR) {
    ctx.beginPath();
    ctx.roundRect(px, py, w, h, r);
    ctx.fill();
  } else {
    ctx.fillRect(px, py, w, h);
  }
}

/** Snaps to whole pixels so the neon pixel-art look stays crisp. */
export function pixelRect(px, py, w, h, col) {
  ctx.fillStyle = col;
  ctx.fillRect(Math.round(px), Math.round(py), w, h);
}
